import nengi from 'nengi'
import { jsonString } from '../../utils/primitive-types'

class ItemListingsMetadataMessage {
	static protocol = {
		listings: { type: nengi.String },
	}

	listings: jsonString

	constructor(itemListings) {
		this.listings = JSON.stringify(itemListings)
	}
}

export default ItemListingsMetadataMessage
